import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE} from "../../../components/i18n/i18n";
import {PH_CODE} from "../../../components/i18n/placeHolders";
import {FL_CATEGORY, FL_TYPE_AMENITY} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import {amenityTypeProvider} from "../../../providers/amenityTypeProvider";



const AmenityFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [amenityType, setAmenityType] = useState(filter?.item?.amenityType?.id);
    const [categoryId, setCategoryId] = useState(filter?.item?.category?.id);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            onlyRegistered,
            item : {  ...data, }
        };

        if (amenityType !== undefined && amenityType !== null )
            dataFilter.item.type = { id : amenityType };

        if (categoryId !== undefined && categoryId !== null )
            dataFilter.item.category = { id : categoryId };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setAmenityType(null);
        setCategoryId(null);
        reset({
            code: '',
            desc: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Descripción'}</Label>
                        <Input
                            type="text"
                            name="desc"
                            placeholder={''}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col>
                    <FormGroup md="2">
                        <Label>{FL_CATEGORY}</Label>
                        <SelectGeneric
                            initialValue={categoryId}
                            setExternalValue={setCategoryId}
                            provider={hotelCategoryProvider}
                            getAllCategories={true}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{FL_TYPE_AMENITY}</Label>
                        <SelectGeneric
                            initialValue={amenityType}
                            setExternalValue={setAmenityType}
                            provider={amenityTypeProvider}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>Solo en app</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={onlyRegistered}
                            onChange={ () => setOnlyRegistered(!onlyRegistered) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={cleanFields}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(AmenityFilters)